import styled from '@emotion/styled';
import theme from 'utils/theme';

export const ContainerFooter = styled.footer`
  display: flex;
  flex-direction: row;
  flex: 1;
  bottom: 0;
  width: 100%;
  border-top: 3px solid ${theme.colors.gold[100]};
  background-color: ${theme.colors.blue3[100]};
  color: ${theme.colors.grey[90]};
  padding: 10px 0;
  z-index: 1000;

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.phablet}px) {
    flex-direction: column;
    padding: 1em 0 0 0;
  }
`;

export const ContainerFooterColStart = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding-left: 30px;
  font-size: ${theme.typography.large16};

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.phablet}px) {
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 1em;
  }
`;

export const ContainerFooterColEnd = styled.div`
  flex: 5;
  align-items: center;
  padding: 0.7rem 1.2rem 0.5rem 0.8rem;
  border-radius: 0.7rem;
  outline: none;
  font-size: ${theme.typography.large16};

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.phablet}px) {
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 1em;
  }
`;

export const ParFooter = styled.p<{ widthCol?: number }>`
  text-align: left;
  width: ${({ widthCol }) => widthCol || 100}%;

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.phablet}px) {
    width: 100%;
  }
`;
